<div class="split-button-wrapper">
    <div class="split-button ms-bgc-w">
        <button [ngClass]="{ 'generic-button generic-button--fluent generic-button--fluent--primary ms-bgc-tp ms-bgc-w-h ms-bgc-w-a ms-fcl-w ms-fcl-tp-h ms-fcl-tp-a' : !fluentRefresh,
                             'generic-button--fluentvnext generic-button--fluentvnext--primary' : fluentRefresh,
                             'split-button__primary-button' : dropdownMenuModel?.items?.length}"
                (click)="buttonModel.primaryAction.executeAction()"
                [attr.aria-label]="buttonModel.primaryAction.ariaLabel"
                [attr.aria-describedby]="buttonModel.id + '-primary-button-description'"
                data-clicklog="custom"
                [ohpFocusOnLoad]="true">
            <ohp-icon-font [iconFontType]="buttonModel.primaryAction.icon"
                            [size]="16"
                            [cssClass]="buttonModel.primaryAction.iconCssClass">
            </ohp-icon-font>
            <span [ngClass]="{'generic-button__text': !fluentRefresh}">{{ buttonModel.primaryAction.title }}</span>
        </button>
        <p class="aria-description" id="{{ buttonModel.id + '-primary-button-description' }}">{{ buttonModel.primaryAction.ariaDescription }}</p>
        <ohp-dropdown-menu *ngIf="dropdownMenuModel?.items?.length"
                           [menuModel]="dropdownMenuModel"
                           [mobileContextMenu]="mobileMenu"
                           (toggleMenu)="onToggleMenu($event)"
                           (selectItem)="onSelectItem($event)"
                           [overridePositioning]="true">
            <div ohpMenuLinkContent>
                <ohp-icon-font iconFontName="ChevronDown"
                               [size]="fluentRefresh ? 8 : 12"
                               [cssClass]="fluentRefresh ? 'split-button__icon--fluent' : 'split-button__icon'"
                               [ariaVisible]="true">
                </ohp-icon-font>
            </div>
            <ng-container *ohpDropdownMenuItemContent="let item = item; let index = index">
                <ohp-icon-font [iconFontType]="item.icon"
                               [cssClass]="'menu-item__icon ' + item.iconCssClass"
                               size="16"
                               [color]="item.iconColor">
                </ohp-icon-font>
                <div class="list-item__title menu-item__title ms-fcl-np">{{ item.title }}</div>
            </ng-container>
        </ohp-dropdown-menu>
    </div>
</div>
